import { makeAxiosRequest } from 'utils/apiMethods';

export interface RecalibrationResult {
  constant: number;
  converter: number;
  cable_length: number;
}

interface DeviceApi {
  fetchDevices: (data: any) => Promise<any>;
  fetchDevice: any;
  putFormula: any;
  applyFormula: any;
  putTarget: any;
  putDevice: any;
  fetchDeviceReadingsLast10Days: any;
  recalibrateDevice: any;
}

const deviceApi: DeviceApi = {
  fetchDevices: makeAxiosRequest(`${process.env.REACT_APP_API_URL}/devices/`, {
    method: 'get',
  }),
  fetchDevice: (serialKey: string) =>
    makeAxiosRequest(`${process.env.REACT_APP_API_URL}/devices/${serialKey}`, {
      method: 'get',
    }),
  putDevice: (serialKey: string, data: Record<string, any>) =>
    makeAxiosRequest(
      `${process.env.REACT_APP_API_URL}/devices/${serialKey}`,
      {
        method: 'put',
      },
      true,
      data,
    ),
  putFormula: (targetId: number, formulaId: number, data: Record<string, any>) =>
    makeAxiosRequest(
      `${process.env.REACT_APP_API_URL}/targets/${targetId}/formula/${formulaId}`,
      {
        method: 'put',
      },
      true,
      data,
    ),
  applyFormula: (serial: string, data: { start: string; end: string }) =>
    makeAxiosRequest(
      `${process.env.REACT_APP_API_URL}/devices/${encodeURIComponent(serial)}/apply-formula`,
      {
        method: 'post',
      },
      true,
      data,
    ),
  putTarget: (targetId: number, data: Record<string, any>) =>
    makeAxiosRequest(
      `${process.env.REACT_APP_API_URL}/targets/${targetId}`,
      {
        method: 'put',
      },
      true,
      data,
    ),
  fetchDeviceReadingsLast10Days: (deviceId: string) =>
    makeAxiosRequest(
      `${process.env.REACT_APP_API_URL}/devices/readings/${deviceId}/last-10-days`,
      {
        method: 'get',
      },
      true,
    ),
  recalibrateDevice: (serialKey: string, data: Record<string, any>) =>
    makeAxiosRequest(
      `${process.env.REACT_APP_API_URL}/devices/${serialKey}/recalibrate`,
      {
        method: 'post',
      },
      true,
      data,
    ),
};

export default deviceApi;
